export class TimeSlotKey implements ITimeSlotKey {
    constructor(timeSlotGroupKey: number, timeSlotKey1: string, timeSlotKey2: number) {
        this.timeSlotGroupKey = timeSlotGroupKey;
        this.timeSlotKey1 = timeSlotKey1?.toString();
        this.timeSlotKey2 = timeSlotKey2;
    }

    timeSlotGroupKey: number;
    timeSlotKey1: string;
    timeSlotKey2: number;

    equal = (other: ITimeSlotKey): boolean => (
        other?.timeSlotGroupKey === this.timeSlotGroupKey
            && other?.timeSlotKey1 === this.timeSlotKey1
            && other?.timeSlotKey2 === this.timeSlotKey2
    );
}

export interface ITimeSlotKey {
    timeSlotGroupKey: number;
    timeSlotKey1: string;
    timeSlotKey2: number;

    equal(other: ITimeSlotKey): boolean;
}